export default class PlayerState {
    fullscreen: boolean = false;
    mute: boolean = false;
    playing: boolean = true;
    volume: number = 75;
    currentTime: number = 0;
    totalTime: number = 0;
    ctrlCurrentTime: number = 0;
    showCaption: boolean = false;
    showTranscript: boolean = false;
    ratingSubmitted: boolean = false;
    playerContainerClassName: string = '';
}

export enum StackType {
    EXIT = -1,
    RATING_PANEL = 0,
    COMMENT_PANEL = 1,
    THANKYOU_PANEL = 2,
}
